/* eslint-disable react/jsx-props-no-spreading */
import { Layer } from 'grommet';
import { ReactNode, useEffect, useState } from 'preact/compat';

interface ProductsPromptModalProps {
  children: ReactNode;
  onClickOutside?: () => void;
}

const ProductsPromptModal = ({ children, onClickOutside }: ProductsPromptModalProps) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          setIsMobile(document.body.classList.contains('group/mobile-layout'));
        }
      });
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    // Initial check
    setIsMobile(document.body.classList.contains('group/mobile-layout'));
    // Cleanup
    return () => observer.disconnect();
  }, []);

  return (
    <Layer
      // key is used to force re-render the modal when the layout changes
      key={isMobile ? 'mobile' : 'desktop'}
      full={isMobile ? 'horizontal' : undefined}
      animation={isMobile ? 'slide' : 'fadeIn'}
      position={isMobile ? 'bottom' : undefined}
      className="!overflow-auto !rounded-t-2xl mobile:!max-w-full desktop:!w-[calc(100%-3rem)] desktop:!max-w-[406px] desktop:!rounded-b-2xl"
      onEsc={onClickOutside}
      onClickOutside={onClickOutside}
    >
      {children}
    </Layer>
  );
};

export default ProductsPromptModal;
